import { User } from '../types/models';

// Fabrika bazlı roller. Fabrika yöneticisi de is_staff olduğu için mevcut yönetim ekranları
// kendi fabrikasıyla sınırlı olarak ona da açıktır; backend veriyi fabrikaya göre süzer.

export const isGeneralAdmin = (user?: User | null) => user?.role === 'general_admin';

export const isFactoryManager = (user?: User | null) => user?.role === 'factory_manager';

export const getRoleLabel = (user?: User | null) => {
  switch (user?.role) {
    case 'general_admin':
      return 'Genel Admin';
    case 'factory_manager':
      return `Fabrika Yöneticisi${user.factory ? ` · ${user.factory.name}` : ''}`;
    case 'driver':
      return `Sürücü${user.factory ? ` · ${user.factory.name}` : ''}`;
    default:
      return user?.is_staff ? 'Admin' : 'Sürücü';
  }
};
